import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabservice() {



const cardData = {
  keyword: " Pune Cab Service",

"headingDescription": "SRS Cab Service provides reliable and comfortable cab travel across Pune, offering a seamless and hassle-free experience for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups ensure a safe and convenient journey. We offer flexible travel options including one-way trips, round trips, and customized itineraries, all with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, SRS Cab Service is the trusted choice for travel within Pune.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort in Pune, famous for its grand architecture and significance as the seat of the Peshwas of the Maratha Empire. Travelers using SRS Cab Service often visit this landmark to admire the gates, explore the ruins, and capture memorable photographs of Pune’s rich heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent Pune landmark associated with India’s freedom movement and Mahatma Gandhi. Visitors traveling with SRS Cab Service can explore its elegant architecture, peaceful gardens, and museum exhibits, making it a must-visit for history and culture enthusiasts."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located near Pune, is renowned for its scenic landscapes and Maratha history. Travelers using SRS Cab Service often include this fort in their itinerary for trekking adventures, breathtaking views, and capturing the natural beauty of Pune’s surrounding hills."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. Visitors traveling with SRS Cab Service frequently stop here to seek blessings, experience spiritual serenity, and witness vibrant local traditions that showcase Pune’s devotional culture."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva in central Pune. Travelers using SRS Cab Service can enjoy the peaceful atmosphere, admire the intricate carvings, and explore this historic monument located in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts including sculptures, musical instruments, and decorative items. Visitors using SRS Cab Service can explore Pune’s artistic heritage and discover traditional craftsmanship preserved through the museum’s exhibits."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple is one of Pune’s oldest heritage sites, offering panoramic views of the city. Travelers using SRS Cab Service often climb the hill to enjoy scenic vistas, visit historic temples, and experience a blend of spirituality and history in one of Pune’s most charming locations."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular getaway near Pune, known for its calm waters and scenic surroundings. Visitors using SRS Cab Service often stop here to enjoy sunsets, photography, and relaxing walks, making it a perfect spot to unwind from city life."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a serene Japanese-style garden. Travelers using SRS Cab Service can enjoy walking paths, lush greenery, and the peaceful environment, making it ideal for leisure and photography."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace in Pune linked to the childhood of Chhatrapati Shivaji Maharaj. Visitors traveling with SRS Cab Service can explore this landmark to learn about Maratha history, admire its architecture, and immerse themselves in Pune’s cultural legacy."
  }
],



services: [
{
name: "Pune Cab Service",
description: "Pune cab service offers reliable and comfortable transportation solutions for daily travel, airport transfers, and outstation journeys. With a wide fleet of vehicles including sedan, hatchback, SUV, and luxury cars, passengers can choose according to their budget and travel needs. Professional drivers ensure safe driving and timely pickups from any location in Pune. Whether you are commuting within the city or planning a long-distance trip, Pune cab services provide seamless booking options. Available 24/7, these services cater to individuals, families, and corporate clients. Affordable pricing and transparent billing make it a preferred choice for travelers. Online booking and instant confirmation add convenience for users. Clean and well-maintained vehicles ensure a comfortable ride experience. Pune cab services are ideal for tourists exploring nearby destinations as well. Experience smooth and hassle-free travel with trusted cab providers in Pune."
},
{
name: "Pune Taxi Service",
description: "Pune taxi service provides efficient and dependable transportation across the city and beyond. Whether you need a ride for office commute, airport transfer, or outstation travel, taxi services in Pune are always available. Drivers are experienced and well-trained, ensuring safe and comfortable journeys. The service includes multiple vehicle options like sedan, SUV, and premium cars for different travel requirements. With easy online booking and quick confirmation, customers can schedule rides anytime. Transparent fare structure ensures no hidden charges during the journey. Pune taxi services are suitable for solo travelers, families, and corporate users. Clean interiors and air-conditioned vehicles enhance the travel experience. Round trip and one-way options are available for flexibility. Enjoy stress-free travel with trusted taxi services in Pune."
},
{
name: "Pune Car Rentals",
description: "Pune car rentals offer flexible transportation solutions for travelers who prefer self-drive or chauffeur-driven options. Customers can rent vehicles for local use, airport transfers, or outstation trips. A wide range of cars including hatchbacks, sedans, SUVs, and luxury vehicles are available to suit every budget. Rental services provide well-maintained vehicles with proper documentation and insurance coverage. Easy booking options allow users to reserve cars online with minimal effort. Affordable pricing plans with hourly, daily, and weekly packages are available. Professional chauffeurs ensure safe and smooth travel for those opting for driver services. Car rentals are ideal for tourists, business travelers, and family trips. Flexible pickup and drop locations add convenience for users. Experience freedom and comfort with reliable car rental services in Pune."
},
{
name: "Pune Airport Taxi",
description: "Pune airport taxi service offers timely and reliable transportation to and from Pune Airport. Whether you are arriving or departing, airport taxis ensure punctual pickups and drop-offs. Professional drivers track flight timings to avoid delays and ensure smooth travel. Comfortable vehicles with ample luggage space make airport transfers hassle-free. Services are available 24/7 to accommodate early morning and late-night flights. Easy online booking allows customers to schedule rides in advance. Transparent pricing ensures no surge charges during peak hours. Airport taxi services cater to individuals, families, and corporate travelers. Clean and sanitized vehicles ensure a safe travel experience. Enjoy stress-free airport transfers with dependable Pune airport taxi services."
},
{
name: "Pune Local Cabs",
description: "Pune local cabs provide convenient transportation for daily commuting within the city. Whether you need a ride for office, shopping, or local sightseeing, local cab services are readily available. Customers can choose from a variety of vehicles including hatchbacks, sedans, and SUVs. Affordable pricing makes local travel economical and budget-friendly. Drivers are familiar with city routes, ensuring quick and efficient travel. Flexible booking options allow customers to hire cabs for hourly or full-day use. Clean and well-maintained vehicles ensure a comfortable ride experience. Local cab services are ideal for residents and tourists alike. Online booking and instant confirmation add convenience for users. Travel easily across Pune with reliable local cab services."
},
{
name: "Taxi Booking Pune",
description: "Taxi booking Pune services provide easy and convenient options for reserving cabs online or via phone. Customers can book taxis instantly for local rides, airport transfers, or outstation trips. User-friendly booking platforms ensure a seamless experience for travelers. Multiple vehicle options are available to suit different travel needs and budgets. Transparent pricing and upfront fare details eliminate confusion. Professional drivers ensure safe and timely travel for passengers. Taxi booking services operate round the clock for maximum convenience. Customers can schedule rides in advance or book instantly. Clean vehicles and reliable service enhance customer satisfaction. Enjoy quick and hassle-free taxi booking services in Pune."
},
{
name: "Pune Chauffeur Service",
description: "Pune chauffeur service offers premium travel experience with professional drivers for business and personal needs. Chauffeur-driven cars provide luxury, comfort, and convenience for city and outstation travel. Experienced drivers ensure safe driving and excellent customer service. Ideal for corporate travel, events, and VIP transportation. Customers can choose from luxury sedans, SUVs, and high-end vehicles. Flexible booking options allow hourly or full-day services. Chauffeur services focus on punctuality and professionalism. Clean and well-maintained vehicles ensure a premium travel experience. Perfect for business meetings, weddings, and special occasions. Enjoy a stress-free and luxurious ride with chauffeur services in Pune."
},
{
name: "Affordable Cabs Pune",
description: "Affordable cabs Pune offer budget-friendly transportation solutions for daily and long-distance travel. Customers can choose economical vehicle options without compromising comfort and safety. Transparent pricing ensures no hidden charges during the ride. Services are available for local travel, airport transfers, and outstation trips. Drivers are experienced and ensure smooth and safe journeys. Easy online booking allows quick reservation of cabs. Affordable cabs are ideal for students, office commuters, and families. Clean and well-maintained vehicles enhance the travel experience. Flexible booking options add convenience for users. Travel economically with trusted affordable cab services in Pune."
},
{
name: "Pune to Mumbai Cab",
description: "Pune to Mumbai cab service provides reliable intercity transportation via the Mumbai–Pune Expressway. Comfortable vehicles ensure smooth and safe highway travel for passengers. Customers can choose from sedan, SUV, and luxury car options. Professional drivers ensure timely pickups and drop-offs from any location. One-way and round trip options are available for flexibility. Transparent pricing ensures fair and affordable travel costs. Ideal for business trips, airport transfers, and family travel. Online booking allows easy reservation of rides. Clean and well-maintained vehicles ensure comfort during long journeys. Enjoy hassle-free travel between Pune and Mumbai with trusted cab services."
},
{
name: "Pune to Shirdi Cab",
description: "Pune to Shirdi cab service offers comfortable and convenient travel for pilgrims visiting Sai Baba Temple. Reliable vehicles ensure smooth highway travel for long-distance journeys. Customers can choose from various car options including sedan and SUV. Professional drivers are familiar with the route and ensure safe travel. One-way and round trip packages are available for flexibility. Affordable pricing makes the journey budget-friendly. Ideal for family trips, group travel, and religious tours. Online booking allows easy trip planning in advance. Clean vehicles ensure a pleasant travel experience. Travel comfortably from Pune to Shirdi with trusted cab services."
},
{
name: "Pune to Mahabaleshwar Cab",
description: "Pune to Mahabaleshwar cab service offers scenic and comfortable travel to one of Maharashtra’s popular hill stations. Well-maintained vehicles ensure smooth travel through ghat roads. Customers can choose from sedan, SUV, and luxury cars. Professional drivers ensure safe driving in hilly terrain. One-way and round trip options are available for tourists. Ideal for family vacations, weekend trips, and honeymoon travel. Affordable pricing makes travel convenient and budget-friendly. Online booking ensures quick and easy reservations. Clean vehicles enhance the overall travel experience. Enjoy a refreshing journey from Pune to Mahabaleshwar with reliable cab services."
},
{
name: "24 Hours Cab Service Pune",
description: "24 hours cab service Pune provides round-the-clock transportation for all travel needs. Whether it is early morning airport transfer or late-night travel, cabs are always available. Customers can book rides anytime without worrying about availability. A wide range of vehicles ensures options for every budget and requirement. Professional drivers ensure safe and timely journeys at all hours. Transparent pricing ensures fair charges without surge pricing. Ideal for emergency travel, business trips, and night journeys. Easy online booking adds convenience for users. Clean and well-maintained vehicles ensure a comfortable ride. Travel anytime with dependable 24-hour cab services in Pune."
}
],

tableData: [
["Pune Cab Service","Pune Taxi Service"],
["Pune Car Rentals","Pune Airport Taxi"],
["Pune Local Cabs","Taxi Booking Pune"],
["Pune Chauffeur Service","Affordable Cabs Pune"],
["Pune to Mumbai Cab","Pune to Shirdi Cab"],
["Pune to Mahabaleshwar Cab","24 Hours Cab Service Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Local & Outstation Drivers",
    WhyChoosedescription: "SRS Cab Service provides highly experienced drivers who are well familiar with Pune city routes, highways, and nearby tourist destinations. Their expertise ensures smooth navigation, safe driving, and timely travel for both local and outstation journeys."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "SRS Cab Service offers budget-friendly Pune cab services with complete pricing transparency. Customers receive clear fare details without hidden charges, making it easy to plan travel within Pune or for outstation trips."
  },
  {
    WhyChooseheading: "24/7 Cab Booking in Pune",
    WhyChoosedescription: "Our Pune cab service operates round the clock to serve all your travel needs. Whether it’s an early morning airport drop, late night pickup, or emergency travel, SRS Cab Service is always available."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Comfortable Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well-maintained, air-conditioned, and regularly cleaned for hygiene and comfort. We ensure a relaxing travel experience for local rides, airport transfers, and long-distance journeys."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Cab Options",
    WhyChoosedescription: "SRS Cab Service offers flexible travel options including local hourly packages, full-day rentals, airport transfers, one-way drops, and round-trip cab services from Pune to multiple destinations."
  },
  {
    WhyChooseheading: "Wide Range of Cab Options",
    WhyChoosedescription: "Choose from a variety of vehicles such as sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel. We cater to individuals, families, and corporate clients."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient doorstep pickup from all areas of Pune including Hinjewadi, Wakad, Baner, Kharadi, Hadapsar, Viman Nagar, and Pune Airport, ensuring hassle-free travel for customers."
  },
  {
    WhyChooseheading: "Trusted Pune Cab Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted by thousands of customers for reliable Pune taxi service. With punctual drivers, quality vehicles, and professional service, we ensure a safe and comfortable journey every time."
  }
]
}

const faqData = [
  { question: "Do you provide Pune cab service?", answer: "Yes, SRS Cab Service offers reliable Pune cab services for local travel, airport transfers, and outstation trips with professional drivers." },
  { question: "Is Pune cab service available 24 hours?", answer: "Yes, our Pune cab service is available 24/7 for all types of travel including early morning and late-night bookings." },
  { question: "Which areas do you cover in Pune?", answer: "We provide cab services across all major Pune areas including Hinjewadi, Wakad, Baner, Aundh, Kharadi, Hadapsar, Viman Nagar, and Pune Airport." },
  { question: "What types of vehicles are available?", answer: "SRS Cab Service offers sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers for group travel." },
  { question: "Do you provide airport cab service in Pune?", answer: "Yes, we provide pickup and drop services to Pune Airport with timely and reliable cab service." },
  { question: "Can I book a cab for outstation travel from Pune?", answer: "Yes, we offer outstation cab services from Pune to Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, and many more destinations." },
  { question: "Are your vehicles air-conditioned?", answer: "Yes, all vehicles provided by SRS Cab Service are fully air-conditioned for a comfortable travel experience." },
  { question: "How can I book Pune cab service?", answer: "You can easily book SRS Cab Service online or by calling our customer support for quick and hassle-free booking." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way as well as round-trip cab services from Pune at affordable rates." },
  { question: "Are cabs cleaned and sanitized regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized to maintain safety and hygiene for passengers." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback:
      "Booked SRS Cab Service for Pune local travel. The driver was polite, and the car was very clean. Great experience overall.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Kulkarni",
    feedback:
      "Reliable and affordable Pune cab service. Used it for airport transfer and the service was on time and very comfortable.",
    rating: 5
  }
];



































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Service | SRS Cab",
  "description": "SRS Cab offers reliable Pune cab services including Pune Taxi Service, Pune Car Rentals, Pune Airport Taxi, Local Cabs, Outstation trips, Chauffeur Services, and affordable rides. Book online for Pune to Mumbai, Pune to Shirdi, Pune to Mahabaleshwar, Pune to Kolhapur, and airport transfers. Enjoy safe, comfortable, and punctual rides with 24x7 online booking in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Pune Cab Service | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune cab service with SRS Cab. Offering Pune Taxi Service, Airport Taxi, Local & Outstation Cabs, Pune to Mumbai, Shirdi, Mahabaleshwar, Kolhapur trips. 24x7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabservice;